import { useSelector } from "react-redux";
import { Typography } from "antd";
import { useWidgetData } from "../Contexts/dashboardHooks";
import { resolveDateRange } from "../Utils/resolveDateRange";
import type { StatComponentSpec, StatTileNonSeriesResponse } from "../Processing/types";

const { Text } = Typography;

const AGG_BADGE: Record<string, { label: string; color: string }> = {
  avg:  { label: "A", color: "#1790ff" },
  best: { label: "B", color: "#008000" },
  sum:  { label: "C", color: "#800080" },
};

const AGG_LABEL: Record<string, string> = { avg: "Average", sum: "Sum", best: "Best" };

function buildInfoContent(
  spec: StatComponentSpec,
  ms: StatTileNonSeriesResponse,
  comparisonTypes: { label: string; value: string }[],
): React.ReactNode {
  const misc = spec.stat_tile_builder_misc;
  if (!misc) return null;

  const badgeLabel = AGG_BADGE[misc.metricAgg]?.label ?? "A";
  const aggLabel = AGG_LABEL[misc.metricAgg] ?? misc.metricAgg;
  const dateRangeLabel = resolveDateRange(misc);
  const subjectsLabel = misc.selectedSubjectNames?.length
    ? misc.selectedSubjectNames.join(", ")
    : "Full Team";
  const comparisonLabel = comparisonTypes.find((c) => c.value === misc.comparisonType)?.label ?? misc.comparisonType;

  return (
    <div style={{ maxWidth: 300, fontSize: 12, lineHeight: 1.6 }}>
      <Text strong style={{ fontSize: 12 }}>[{badgeLabel}] {ms.name}</Text>
      <div style={{ paddingLeft: 4, color: "rgba(0,0,0,0.65)" }}>
        <div>Aggregate: {aggLabel}</div>
        <div>Dates: {dateRangeLabel}</div>
        <div>Players: {subjectsLabel}</div>
        {comparisonLabel && <div>Comparison: {comparisonLabel}</div>}
      </div>
    </div>
  );
}

export function StatInfo({ id }: { id: string }) {
  const data = useWidgetData(id);
  const comparisonTypes: { label: string; value: string }[] =
    useSelector(({ team }: any) => team?.misc?.comparison_types) ?? [];

  if (!data || data.type !== "stat_tile" || !data.stat?.metricStat) return null;

  return buildInfoContent(data.spec, data.stat.metricStat, comparisonTypes);
}
